export default class NextServiceUtils {
  static getNextServiceDateBg(date: string | undefined): string {
    if (!date) return '';

    const today = new Date();
    const nextServiceDate = new Date(date);

    if (today.getTime() - nextServiceDate.getTime() > 0) {
      return 'var(--dv-bg-surface-danger-active)';
    }

    const diffInTime = today.getTime() - nextServiceDate.getTime();
    const diffInDays = Math.abs(Math.round(diffInTime / (1000 * 3600 * 24)));

    if (diffInDays < 31) {
      return 'var(--dv-bg-surface-warning-active)';
    }

    return '';
  }
}
